/*
  Sold-out "notify me when available" button (Grow / CartBite back-in-stock app).

  Why the theme renders this button at all:

    - The app injects `.gw-collection-page-button` by scanning product cards, but on /search it
      only does so through a slow scroll/observer pass — its own re-scan (`gwCollectionPageRender`)
      no-ops outside collection URLs. The button appeared seconds late and vanished again on
      every InstantSearch filter or sort.
    - A sold-out card hides its add-to-cart (CSS), so without this the card has no action at all.

  Contract with the app:

    - reusing its `.gw-collection-page-button` class means the app's own scan finds a button
      already present and skips the card, so there is never a duplicate;
    - `initVar.stockWidgetClicked(e)` opens the modal for the product it reads from
      `e.currentTarget`'s data attributes. The app has no click delegation of its own, which is
      why the listener sits on the button rather than on the document.

  Availability is our own value, including the minimum-stock floor — see
  snippets/pz.product-availability.liquid. The trigger is the `pz:search:sold-out` event that
  search.algolia.enrich.js dispatches once the fragment says a card is unavailable.
*/
window.PZSearch = window.PZSearch || {}

;(function (PZSearch) {
  'use strict'

  /*
    The app ships its own translations, keyed by locale. Prefer them so the button matches the
    modal it opens; fall back to the theme string only when the app hasn't loaded them.
  */
  function appLabel() {
    try {
      const initVar = window.initVar
      if (!initVar) return null

      const locale = (window.Shopify && window.Shopify.locale) || 'en'
      const translations = initVar.translationJson && initVar.translationJson[locale]
      const fromTranslations =
        translations &&
        translations.stockWidget &&
        translations.stockWidget.widget &&
        translations.stockWidget.widget.beforeSubscribeText

      return fromTranslations || (initVar.stockWidget && initVar.stockWidget.subscriptionText) || null
    } catch (e) {
      return null
    }
  }

  PZSearch.createNotify = function createNotify(config) {
    const rootUrl = ((config.routes && config.routes.root) || '/').replace(/\/$/, '')

    return function attach(card) {
      if (!card) return

      const bottom = card.querySelector('.grid-item__meta-main-bottom')
      if (!bottom || bottom.querySelector('.gw-collection-page-button')) return

      const productId = card.dataset.productId || card.dataset.id
      const variantId = card.dataset.variantId
      const handle = card.dataset.handle
      if (!productId || !variantId) return

      const button = document.createElement('button')
      button.type = 'button'
      button.className = 'gw-collection-page-button js-algolia-notify'
      button.setAttribute('data-product-id', productId)
      button.setAttribute('data-variant-id', variantId)
      button.setAttribute('data-product-handle', handle || '')
      button.textContent = appLabel() || config.labels.notifyMe

      button.addEventListener('click', function (event) {
        event.preventDefault()

        if (window.initVar && typeof window.initVar.stockWidgetClicked === 'function') {
          // currentTarget is the button, so the app reads the right product from its data-*.
          window.initVar.stockWidgetClicked(event)
        } else if (handle) {
          // Market/locale-aware, unlike the old theme's hardcoded '/products/'.
          window.location.href = rootUrl + '/products/' + handle
        }
      })

      // Same insert point the app uses: right after the (now hidden) add-to-cart.
      const addToCart = bottom.querySelector('.grid-product__add-to-cart')
      if (addToCart && addToCart.nextSibling) {
        bottom.insertBefore(button, addToCart.nextSibling)
      } else {
        bottom.appendChild(button)
      }
    }
  }
})(window.PZSearch)
